import xaccelClient from '@/utils/xaccel-client'
import { MONITOR_STATUS_PATH } from '@/services/admin-service'

// Stream monitor (procricket-monitoring), read through B-API: GET {VUE_APP_BAPI}monitor-status?providerName=monitor,
// one call for every monitored channel. B-API forwards it to the monitor (config/xaccel/get-monitor-status.yaml).

export interface MonitorVariantStatus {
    name: string
    healthy: boolean
    classification: string | null
    is_frozen: boolean | null
    last_checked_at: string | null
    error: string | null
}

export interface MonitorChannelStatus {
    cal_channel_id: number
    channel_name: string
    origin: string
    encoder: string
    phase: string
    started_at: string | null
    error: string | null
    last_cycle_at: string | null
    variants: MonitorVariantStatus[]
}

class MonitorService {
    public readonly url = MONITOR_STATUS_PATH;

    public getStatus(): Promise<MonitorChannelStatus[]> {
        return xaccelClient.get(MONITOR_STATUS_PATH, { timeout: 8000 }).then(res => (res.data && res.data.channels) || []);
    }
}

export default new MonitorService()
